import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';

function Funcionalidades() {
    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h1 className="h4">Funcionalidades</h1>
                        <p className="mb-0 text-gray">Detalhes das principais areas do EasyCripto</p>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-12">
                        <div className="card border-0 shadow-sm mb-4" style={{ background: 'linear-gradient(135deg, #4c51bf 0%, #6b46c1 100%)' }}>
                            <div className="card-body text-white p-4">
                                <h2 className="h5 mb-2">Visão geral</h2>
                                <p className="mb-0">
                                    Aqui voce encontra um resumo claro de cada area do sistema, com o objetivo de entender
                                    onde cada funcionalidade se encaixa no seu fluxo de trading.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #3b82f6' }}>
                            <div className="card-body p-4">
                                <h3 className="h5 mb-2">Dashboard</h3>
                                <p className="mb-0">
                                    Visão rápida do mercado, livro de ordens e carteira, com informações em tempo real.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #10b981' }}>
                            <div className="card-body p-4">
                                <h3 className="h5 mb-2">Carteira</h3>
                                <p className="mb-0">
                                    Acompanhe seus saldos, valor estimado e detalhes de cada ativo em cards.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #f59e0b' }}>
                            <div className="card-body p-4">
                                <h3 className="h5 mb-2">Comprar/Vender</h3>
                                <p className="mb-0">
                                    Execucao de ordens MARKET e LIMIT com validacoes e calculo automatico do total.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #8b5cf6' }}>
                            <div className="card-body p-4">
                                <h3 className="h5 mb-2">Swap</h3>
                                <p className="mb-0">
                                    Troca de ativos usando ordens de mercado, com cotação prévia.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #ef4444' }}>
                            <div className="card-body p-4">
                                <h3 className="h5 mb-2">Agente IA</h3>
                                <p className="mb-0">
                                    Sugestoes, informacoes de mercado e suporte para tomada de decisao.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #0ea5e9' }}>
                            <div className="card-body p-4">
                                <h3 className="h5 mb-2">Estratégias e Automações</h3>
                                <p className="mb-0">
                                    Crie, gerencie e execute estrategias automaticas com regras personalizadas.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #22c55e' }}>
                            <div className="card-body p-4">
                                <h3 className="h5 mb-2">Relatorios</h3>
                                <p className="mb-0">
                                    Acompanhe performance, volume de compra/venda e histórico de operações.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #64748b' }}>
                            <div className="card-body p-4">
                                <h3 className="h5 mb-2">Monitores e Webhooks</h3>
                                <p className="mb-0">
                                    Monitore sinais e integre eventos externos para acionar acoes automaticas.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </main>
        </>
    );
}

export default Funcionalidades;

